import React from "react";
import { useLocaleContext } from "../../../../context/LocaleContext";
import { EMOJI_CATEGORIES_I18N_KEYS } from "../../../../constants/components/emoji";
import EmojiButton from "./EmojiButton";

const EmojiListItem = ({category, emojiList, filteredEmoji, onSelectEmoji, onChangeCategory}) => {
    const { get } = useLocaleContext();

    return (
        <li
            data-emoji-category={category}
            data-type="emoji-list-item"
        >
            <div className="emoji-picker-smileys-item">
                <span className="emoji-picker-smileys-item-name">
                    {get(`emoji.${EMOJI_CATEGORIES_I18N_KEYS[category]}`)}
                </span>
                <span className="emoji-picker-smileys-list">
                    {emojiList?.map((emoji, index) => (
                        filteredEmoji?.includes(index) &&
                        <EmojiButton
                            key={emoji?.codes}
                            emoji={emoji}
                            onClick={onSelectEmoji}
                        />
                    ))}
                </span>
            </div>
        </li>

    );
};

export default EmojiListItem;
